import React from "react";
import { render } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import Root from "./containers/Root";
import configureStore from "./store/configureStore";

import "./css/main.css";
import "./ui/src/ui/main.css";

const store = configureStore();

render(
  <Router>
    <Root store={store} />
  </Router>,
  document.getElementById("app")
);
